export default {
    listing: { method: 'get', url: 'api/guests/access_locations' },
    revoke: { method: 'delete', url: 'api/guests/access_locations/revoke' },
    revokeSelected: { method: 'delete', url: 'api/guests/access_locations/revoke_selected' },    
}

